import React from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';
import { computeResourceDiscoveryApiRef } from '../../api';
import { GcpContextProvider } from './GcpContext';
import { Gcp } from './Gcp';
import { useEntity } from '@backstage/plugin-catalog-react';
import { CRDGCPConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';
import { Alert } from '@mui/material';

type GcpWithProvidersProps = {
  projectCode: string;
  gcpConfigs: CRDGCPConfig[] | undefined;
};

export const GcpWithProviders: React.FC<GcpWithProvidersProps> = ({
  projectCode,
  gcpConfigs,
}) => {
  const { entity } = useEntity<Entity>();
  const api = useApi(computeResourceDiscoveryApiRef);

  if (!gcpConfigs || gcpConfigs.length === 0) {
    return (
      <Alert severity="warning" sx={{ my: 2 }}>
        Gcp configuration not found for project code {projectCode}
      </Alert>
    );
  }

  return (
    <GcpContextProvider
      api={api}
      gcpConfigs={gcpConfigs}
      projectCode={projectCode}
    >
      <Gcp entity={entity} />
    </GcpContextProvider>
  );
};
